"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PropsWithChildren, useState } from "react";

import { SessionProvider } from "@/app/SessionProvider";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { Toaster } from "@/components/ui/sonner";

const Providers = ({ children }: PropsWithChildren) => {
    const [ queryClient ] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 1000 * 60 * 5,
                refetchOnWindowFocus: true,
            },
        },
    }));

    return (
        <QueryClientProvider client={ queryClient }>
            <ReactQueryDevtools initialIsOpen={ false } />
            <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
                <Toaster richColors position="bottom-right" />
                <SessionProvider>{children}</SessionProvider>
            </ThemeProvider>
        </QueryClientProvider>
    );
};

export default Providers;